import React, { useEffect, useState } from "react";
import {
  ReferenceField,
  TextField,
  useDataProvider,
  SimpleShowLayout,
  SelectField,
} from "react-admin";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import { labelDataGridStyles } from "utils/style";
import ShowAreaDatagrid from "./components/ShowAreaDatagrid";
import { tbfCodeList } from "./components/TbfCodeInput";
import ShowWrapper from "../../components/ShowWrapper";
import CustomLabeled from "../../components/layout/CustomLabeled";

const RateChartShow = (props: any) => {
  const [areas, setAreas] = useState([]);
  const provider = useDataProvider();
  const param = GetParam();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Pricing", link: `/schools/${param.get("schoolId")}/show/5` },
    { title: props.id, link: "" },
  ];

  useEffect(() => {
    provider
      .getList("areas", {
        filter: { SchoolId: Number(param.get("schoolId")) },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "MaxDistanceInMeters",
          order: "ASC",
        },
      })
      .then((result) => {
        setAreas(result.data);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        customName={{
          resourceName: "Regular Rate Chart",
          propertyName: "name",
        }}
        actions={null}
        {...props}
      >
        <SimpleShowLayout>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                School & Academic Year
              </Typography>
            </Grid>

            <Grid item xs={3}>
              <CustomLabeled name="School">
                <ReferenceField source="schoolId" reference="schools">
                  <TextField source="name" />
                </ReferenceField>
              </CustomLabeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Academic Year">
                <ReferenceField
                  source="academicYearId"
                  reference="academicYears"
                >
                  <TextField source="name" />
                </ReferenceField>
              </CustomLabeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Tbf Code">
                <SelectField
                  source="tbfCode"
                  choices={tbfCodeList}
                  emptyText="-"
                />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Pricing Details
              </Typography>
            </Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Pricing Name">
                <TextField source="name" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Pricing Start Date">
                <CustomDateField source="startedAt" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Pricing End Date">
                <CustomDateField source="endedAt" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={6}></Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Invoice Issue Date">
                <CustomDateField source="invoiceIssuedAt" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">
                Area Pricing (Exclusive of GST)
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  1 Time a Week
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="oneTimeAWeekPricing"
                  frequency={1}
                  isDisabled
                />
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  2 Time a Week
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="twoTimeAWeekPricing"
                  frequency={2}
                  isDisabled
                />
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  3 Time a Week
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="threeTimeAWeekPricing"
                  frequency={3}
                  isDisabled
                />
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  4 Time a Week
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="fourTimeAWeekPricing"
                  frequency={4}
                  isDisabled
                />
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={labelDataGridStyles}>
                  5 Time a Week
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <ShowAreaDatagrid
                  areas={areas}
                  name="fiveTimeAWeekPricing"
                  frequency={5}
                  isDisabled
                />
              </Grid>
            </Grid>
          </SanitizedGrid>
        </SimpleShowLayout>
      </ShowWrapper>
    </>
  );
};

export default RateChartShow;
